import { useTranslation } from "react-i18next";
import CustomButton from "../../helperComponents/CustomButton";
import { IoIosFitness } from "react-icons/io";

const MyActivitiesHeaderButton = () => {
  const { t } = useTranslation();

  return (
    <CustomButton
      href={"/my-bookings"}
      style={{ borderRadius: "10px", height: "40px", gap: "5px" }}
      textStyle={{ fontSize: "9px" }}
      icon={<IoIosFitness />}
    >
      {t("menuItemMyActivities")}
    </CustomButton>
  );
};

export default MyActivitiesHeaderButton;
